export default __webpack_public_path__ + "static/media/offer-vertical-chocolate.c6a8fd66.png";